import React, { Component } from 'react';
import {
  FormControl, 
  InputLabel,
  Input,
  Select, 
  MenuItem,
  ListItemText,
  Checkbox
} from "@mui/material";

import { 
  Character,
  CharacterItem 
} from "@dndModels";

interface Props {
  character: Character;
  value: string | null;
  values: string[];
  objects: CharacterItem[] | null;
  multiple: boolean;
  name: string;
  onChange: Function;
  labelWidth: number | null;
  color: string;
  disabled: boolean;
}

export interface State { 
  objects: CharacterItem[];
  labelWidth: number;
  // loading: boolean;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class SelectCharacterItemBox extends Component<Props, State> {
  public static defaultProps = {
    labelWidth: null,
    multiple: false,
    value: null,
    values: [],
    allow_all: false,
    allow_none: false,
    color: "",
    objects: [],
    filter: {},
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      objects: (props.objects ? props.objects : props.character.items),
      labelWidth: this.getLabelWidth(props.name),
      // loading: false
    };
  }

  componentDidMount() {
    // this.load();
  }

  getLabelWidth(name: string) {
    const smallCount = 
      this.countOccurences(name, "i") +
      this.countOccurences(name, "l") +
      this.countOccurences(name, "I") +
      this.countOccurences(name, "t") +
      this.countOccurences(name, "r") +
      this.countOccurences(name, " ");

    return ((name.length - smallCount) * 10 + smallCount * 4);
  }

  countOccurences(searchMe: string, findMe: string) {
    return searchMe.split(findMe).length - 1;
  }

  renderValues(selected: string[]) {
    let rendered = "";
    if (this.state.objects) {
      for (let i = 0; i < selected.length; i++) {
        const s = selected[i];
        const oFinder = this.state.objects.filter(o => o.true_id === s);
        if (oFinder.length === 1) {
          if (i > 0) {
            rendered += ",";
          }
          rendered += oFinder[0].name;
        } else {
          // To get ALL and None to show up
          if (i > 0) {
            rendered += ",";
          }
          rendered += s;
        }
      }
    }
    return rendered;
  }

  render() {
    // if (this.props.data_type === "") {
    //   return <span></span>;
    // } else if (this.state.loading || this.state.objects === null) {
    //   return (<LoadingBox />);
    // } else {
    if (this.props.color !== "") {
      return (
        <div style={{
          border: "1px solid #1C9AEF"
        }}>
          { this.renderControl() }
        </div>
      );
    } else {
      return this.renderControl();
    }
    // }
  }

  renderControl() {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel htmlFor={`selectInput_${this.props.name}`}>{this.props.name}</InputLabel>
        { this.props.multiple ? 
          <Select
            labelId={`selectInput_${this.props.name}`}
            id={`selectInput_${this.props.name}`}
            multiple
            fullWidth
            value={this.props.values}
            // labelWidth={ this.props.labelWidth ? this.props.labelWidth : this.state.labelWidth }
            onChange={(event: any) => {
              this.props.onChange(event.target.value as string[]);
            }}
            input={<Input />}
            renderValue={ (selected) => this.renderValues(selected as string[]) }
            disabled={this.props.disabled}
            MenuProps={MenuProps}
          >
            { this.state.objects && this.state.objects.map((opt: CharacterItem, i: any) => (
              <MenuItem key={i} value={opt.true_id}>
                <Checkbox checked={ this.props.values.indexOf(opt.true_id) > -1 } />
                <ListItemText primary={opt.name} />
              </MenuItem>
            ))}
          </Select>
        :
          <Select
            labelId={`selectInput_${this.props.name}`}
            id={`selectInput_${this.props.name}`}
            value={this.props.value ? this.props.value : ""}
            onChange={(event: any) => {
              this.props.onChange(event.target.value);
            }}
            disabled={this.props.disabled}
            fullWidth
            // labelWidth={ this.props.labelWidth ? this.props.labelWidth : this.state.labelWidth }
          >
            { this.state.objects && this.state.objects.map((opt: CharacterItem, i: any) => {
              return (<MenuItem key={i} value={opt.true_id}>{opt.name}</MenuItem>);
            })}
          </Select>
        }
      </FormControl>
    );
  }
}

export default SelectCharacterItemBox;
